(function () {
  'use strict';



  function initMonoProductRouting(scope) {
    var cfg = window.theme || {};
    if (!cfg.redirectCatalogToProduct || !cfg.primaryProductUrl) return;
    (scope || document).querySelectorAll('a[href]').forEach(function (link) {
      if (link.dataset.monoRouteReady === 'true') return;
      link.dataset.monoRouteReady = 'true';
      var href = link.getAttribute('href') || '';
      var text = (link.textContent || '').trim().toLowerCase();
      var isCatalog = href.indexOf('/collections') !== -1 || /(^|\s)(catalogue|catalog|boutique|shop)(\s|$)/i.test(text);
      if (!isCatalog) return;
      link.setAttribute('href', cfg.primaryProductUrl);
    });
  }

  function init(scope) {
    scope = scope || document;

    initMonoProductRouting(scope);

    scope.querySelectorAll('[data-site-header]').forEach(function (header) {
      if (header.dataset.ready === 'true') return;
      header.dataset.ready = 'true';
      var toggle = header.querySelector('[data-nav-toggle]');
      var nav = header.querySelector('[data-main-nav]');
      if (!toggle || !nav) return;
      toggle.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      nav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          header.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      });
    });

    scope.querySelectorAll('[data-faq-group]').forEach(function (group) {
      if (group.dataset.ready === 'true') return;
      group.dataset.ready = 'true';
      var items = group.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });

    scope.querySelectorAll('[data-video-play]').forEach(function (button) {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      button.addEventListener('click', function () {
        var wrap = button.closest('[data-video-wrap]');
        if (!wrap) return;
        var video = wrap.querySelector('video');
        if (!video) return;
        wrap.classList.add('is-playing');
        video.setAttribute('controls', 'controls');
        video.play().catch(function () {});
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
